// extracted by mini-css-extract-plugin
module.exports = {"title":"ChapterListItemStyles__title title","chapterCopy":"ChapterListItemStyles__chapterCopy","chapterContent":"ChapterListItemStyles__chapterContent","chapterLabels":"ChapterListItemStyles__chapterLabels"};
    if(module.hot) {
      // 1790535719840
      var cssReload = require("/var/lib/jenkins/workspace/Player_master/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"locals":true});
      module.hot.dispose(cssReload);
      
    }
  